export const newHoursValidator = (form: unknown, value: unknown) => {
  if (value === '' || value === null || value === undefined) {
    return Promise.reject('Please enter a quantity');
  }

  if (
    (typeof value === 'number' || typeof value === 'string') &&
    !isNaN(parseFloat(value.toString()))
  ) {
    return Promise.resolve();
  }

  return Promise.reject('Please enter a valid number');
};

export function buildEstimationMessage(
  currentMembershipEntityType?: string,
  disputeAuthorEntityType?: string
) {
  if (currentMembershipEntityType === 'Organization') {
    return disputeAuthorEntityType === 'Organization'
      ? '*This is the adjusted Billing Amount. You may edit if you have further changes.'
      : '*This is a Works estimate. Please edit and input the correct Billing Amount if it doesn’t match your calculations.';
  }

  return disputeAuthorEntityType === 'Supplier'
    ? '*This is a Works estimate. You may edit if you have further changes.'
    : '*This is the adjusted Billing Amount. Please accept the dispute if you agree, or edit if you have further changes.';
}

export function getRedirectTargetEntity(
  disputeCreatedByEntity: 'Supplier' | 'Organization' | undefined
): 'Supplier' | 'Organization' | undefined {
  if (disputeCreatedByEntity === undefined) {
    return undefined;
  }

  // FYI: The redirect action defines that who created the dispute should redirect it to the other entity.
  return disputeCreatedByEntity === 'Supplier' ? 'Organization' : 'Supplier';
}
